export const addPartnerOption = {
  value: 'add_partner',
  label: 'AddPartner',
  className: 'text-primary',
};
